// Implementation from https://github.com/redux-saga/redux-saga/issues/178 - jamiesunderland commented on 18 Jan
import { all, fork } from 'redux-saga/effects';

import watchAuth from './Auth/sagas';
import watchContracts from './Contracts/sagas';
import watchDashboard from './Dashboard/sagas';
import watchParties from './Parties/sagas';
import watchProducts from './Products/sagas';
import watchQuotations from './Quotations/sagas';
import watchSalesRoutes from './SalesRoutes/sagas';
import watchSurveys from './Surveys/sagas';
import watchStats from './Stats/sagas';
import watchSystem from './System/sagas';
import watchTheme from './Theme/sagas';

import { mergeWatchers } from '../Utils/Utils';
// Customer
import { dynamicWatchers } from './customer/saga-wrapper';

const defaultWatchers = {
  watchDashboard,
  watchContracts,
  watchAuth,
  watchProducts,
  watchQuotations,
  watchSystem,
  watchParties,
  watchSurveys,
  watchStats,
  watchTheme,
  watchSalesRoutes,
};

const sagas = mergeWatchers({ defaultWatchers, dynamicWatchers });

function* rootSaga() {
  yield all(sagas.map(saga => fork(saga)));
}

export default rootSaga;
